export default () => ({
  MuiDivider: {
    root: {
      backgroundColor: '#e6ecf0'
    }
  }
});
